import { render } from "./DiscussionListModal.vue?vue&type=template&id=2412a043&scoped=true"
import script from "./DiscussionListModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionListModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionListModal.vue?vue&type=style&index=0&id=2412a043&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2412a043"]])

export default __exports__